import React from 'react';
import TableHeaderAddRow from '@/components/table/TableHeaderAddRow';
import DatasetCollectionsDropdown from './DatasetCollectionsDropdown';

const DatasetCollectionsAssignAddRow = ({
  className,
  readStatus,
  filter,
  collections,
  collectionsToAdd,
  collectionsToAddChange,
  onFilterChange,
  addCollections,
}) => (
  <TableHeaderAddRow
    className={className}
    entity="dataset.collection"
    disabled={collectionsToAdd.length === 0}
    onClick={addCollections}
  >
    <DatasetCollectionsDropdown
      collections={collections}
      autoFocus
      onChange={collectionsToAddChange}
      onFilterChange={onFilterChange}
      readStatus={readStatus}
      filter={filter}
      text={collectionsToAdd.map((collection) => collection.code)}
    />
  </TableHeaderAddRow>
);

export default DatasetCollectionsAssignAddRow;
